import { useQuery } from "@tanstack/react-query";

import type { GetReviewTemplatesResponse } from "@performyard/service-contracts";

import request from "../../services/defs/internal-api/internal-base-request";

export const useReviewTemplates = () => {
	return useQuery({
		queryKey: ["review-templates"],
		queryFn: async () => {
			const [response] = await request<GetReviewTemplatesResponse>("/v1/reviews/review-templates");
			return response.data;
		},
		meta: { errorMessage: "There was an error loading review templates." },
	});
};
